const currentUserReducer = (state = null, action) => {
    switch(action.type){
        case 'SETCURRENTUSER':
            return action.payload;
        default:
            return state;
    }
};

export default currentUserReducer;